// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EstimateFeesBodyAnyOf } from './EstimateFeesBodyAnyOf';
import {
    EstimateFeesBodyAnyOfFromJSON,
    EstimateFeesBodyAnyOfFromJSONTyped,
    EstimateFeesBodyAnyOfToJSON,
} from './EstimateFeesBodyAnyOf';
import type { EstimateFeesBodyAnyOf1 } from './EstimateFeesBodyAnyOf1';
import {
    EstimateFeesBodyAnyOf1FromJSON,
    EstimateFeesBodyAnyOf1FromJSONTyped,
    EstimateFeesBodyAnyOf1ToJSON,
} from './EstimateFeesBodyAnyOf1';

/**
 * Contains the base64 encoded serialized transaction
 * @export
 * @interface EstimateFeesBody
 */
export interface EstimateFeesBody {
    /**
     * 
     * @type {string}
     * @memberof EstimateFeesBody
     */
    serializedTx?: string;
    /**
     * 
     * @type {string}
     * @memberof EstimateFeesBody
     */
    message?: string;
}

/**
 * Check if a given object implements the EstimateFeesBody interface.
 */
export function instanceOfEstimateFeesBody(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EstimateFeesBodyFromJSON(json: any): EstimateFeesBody {
    return EstimateFeesBodyFromJSONTyped(json, false);
}

export function EstimateFeesBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateFeesBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serializedTx': !exists(json, 'serializedTx') ? undefined : json['serializedTx'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function EstimateFeesBodyToJSON(value?: EstimateFeesBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'serializedTx': value.serializedTx,
        'message': value.message,
    };
}

